<template>
  <div class="border-t border-grey400">
    <div
      v-if="model.directions"
      class="border-b border-grey400"
    >
      <div
        class="cursor-pointer py-16 flex items-center justify-between"
        @click="toogleExpanded('directions')"
      >
        <h4 class="mb-0 pr-32 text-xsmall-medium sm:text-small-medium">{{ storePageResources.findStore }}</h4>
        <div class="relative h-24 sm:text-small-regular">
          <i class="text-lg sm:text-xl inline-block absolute right-0 top-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="w-20 h-20"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M19.5,12h-15"
              />
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M12 4.5v15m7.5-7.5h-15"
                class="animate-all"
                :class="{'opacity-0': expanded.includes('directions')}"
              />
            </svg>
          </i>
        </div>
      </div>
      <transition>
        <div
          class="pb-24 sm:pb-32 text-xsmall sm:text-small-regular"
          :class="{
            hidden: !expanded.includes('directions')
          }"
        >
          <div class="wysiwyg" v-html="model.directions" />
        </div>
      </transition>
    </div>
    <div
      v-if="model.openingHoursSpecification && model.openingHoursSpecification?.length > 0"
      class="border-b border-grey400"
    >
      <div
        class="cursor-pointer py-16 flex items-center justify-between"
        @click="toogleExpanded('opening')"
      >
        <h4 class="mb-0 pr-32 text-xsmall-medium sm:text-small-medium">{{ storePageResources.openingHours }}</h4>
        <div class="relative h-24 sm:text-small-regular">
          <i class="text-lg sm:text-xl inline-block absolute right-0 top-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="w-20 h-20"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M19.5,12h-15"
              />
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M12 4.5v15m7.5-7.5h-15"
                class="animate-all"
                :class="{'opacity-0': expanded.includes('opening')}"
              />
            </svg>
          </i>
        </div>
      </div>
      <transition>
        <div
          class="pb-24 sm:pb-32 text-xsmall sm:text-small-regular"
          :class="{
            hidden: !expanded.includes('opening')
          }"
        >
          <div class="wysiwyg">
            <div
              v-for="(openingHours, index) in model.openingHoursSpecification"
              :key="index"
              class="mb-6 flex justify-between"
            >
              <span>{{ getDayOfWeek(openingHours.dayOfWeek) }} </span>
              <span>{{ $dayjs(openingHours.opens).format('HH:mm') }} - {{ $dayjs(openingHours.closes).format('HH:mm') }}</span>
            </div>
          </div>
          <h4 v-if="model.specialOpeningHoursSpecification?.length > 0" class="pr-32 mb-0 py-16 text-xsmall-medium sm:text-small-medium">{{ storePageResources.specialOpeningHours }}</h4>
          <div v-if="model.specialOpeningHoursSpecification?.length > 0" class="wysiwyg">
            <div
              v-for="(openingHours, index) in model.specialOpeningHoursSpecification"
              :key="index"
              class="mb-6 flex justify-between"
            >
              <span v-if="openingHours.customHeader">{{ openingHours.customHeader }}</span>
              <span v-else>{{ getDayOfWeek(openingHours.dayOfWeek) }} </span>
              <span v-if="openingHours.description">{{ openingHours.description }}</span>
              <span v-else-if="openingHours.opens && openingHours.closes">{{ $dayjs(openingHours.opens).format('HH:mm') }} - {{ $dayjs(openingHours.closes).format('HH:mm') }}</span>
            </div>
          </div>
        </div>
      </transition>
    </div>
    <div
      v-if="model.email || model.phone"
      class="border-b border-grey400"
    >
      <div
        class="cursor-pointer py-16 flex items-center justify-between"
        @click="toogleExpanded('contact')"
      >
        <h4 class="mb-0 pr-32 text-xsmall-medium sm:text-small-medium">{{ storePageResources.contactStore }}</h4>
        <div class="relative h-24 text-xsmall sm:text-small-regular">
          <i class="text-lg sm:text-xl inline-block absolute right-0 top-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="w-20 h-20"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M19.5,12h-15"
              />
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M12 4.5v15m7.5-7.5h-15"
                class="animate-all"
                :class="{'opacity-0': expanded.includes('contact')}"
              />
            </svg>
          </i>
        </div>
      </div>
      <transition>
        <div
          class="pb-24 sm:pb-32 text-xsmall sm:text-small-regular"
          :class="{
            hidden: !expanded.includes('contact')
          }"
        >
          <div class="">
            <a
              v-if="model.email"
              :href="'mailto:' + model.email"
              class="block underline mb-12 hover:no-underline"
            >
              {{ model.email }}
            </a>
            <a
              v-if="model.phone"
              :href="'tel:' + model.phone"
              class="block underline mb-12 hover:no-underline"
            >
              {{ model.phone }}
            </a>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { StorePage } from '~/content-types';
import { type Ref, ref } from 'vue';
import { useGlobalContentStore } from '~/store/globalContent';

const globalContentStore = useGlobalContentStore();
const storePageResources = globalContentStore.storePageResources;

defineProps<{
  model: StorePage;
}>();

const expanded: Ref<string[]> = ref([]);

const toogleExpanded = (index: string) => {
  if (expanded.value.includes(index)) {
    expanded.value = expanded.value.filter(i => i !== index);
  } else {
    expanded.value.push(index);
  }
};

const getDayOfWeek = function(intValue) {
  if (intValue < 0 || intValue > 6) {
    throw new Error('Invalid value for day of the week. It should be between 0 and 6.');
  }
    
  // Create a date object for the given day of the week.
  // Note: January 1, 1970 is a Thursday, so we adjust the date to start from a Sunday.
  const baseDate = new Date(Date.UTC(1970, 0, 4 + intValue)); // Jan 4, 1970 is a Sunday
    
  // Use Intl.DateTimeFormat to get the localized day name
  const formatter = new Intl.DateTimeFormat('sv-SE', { weekday: 'long' });
    
  const dayName = formatter.format(baseDate);
    
  // Capitalize the first letter
  return dayName.charAt(0).toUpperCase() + dayName.slice(1);
};
</script>
